import React, { useEffect } from 'react'
import { pageTitle } from '../../helper'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import Div from '../Div'
import Spacing from '../Spacing'
import SocialWidget from '../Widget/SocialWidget'

export default function TeamDetails() {
  pageTitle('Team Member');
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading
        title='Team Details'
        bgSrc='/images/team_hero_bg.jpeg'
        pageLinkText='Team Details'
      />
      <Spacing lg='150' md='80' />
      <Div className="container">
        <Div className="row align-items-center">
          <Div className="col-xl-5 col-lg-6">
            <Div className="cs-radius_15 cs-shine_hover_1">
              <img src="/images/member_details_1.jpeg" alt="Member" className="w-100" />
            </Div>
          </Div>
          <Div className="col-lg-6 offset-xl-1">
            <Spacing lg='0' md='45' />
            <Div className="cs-section_heading cs-style1">
              <h2 className="cs-section_title">Jai Chachra              </h2>
              <Div className="cs-height_10 cs-height_lg_10" />
              <h3 className="cs-section_subtitle">Founder</h3>
              <Div className="cs-height_5 cs-height_lg_5" />
              <Div className="cs-separator cs-accent_bg" />
              <Div className="cs-height_45 cs-height_lg_25" />
              <p className="cs-m0">I am passionate about creating and developing brands. My interest in innovation began at the age of 15! when I witnessed the tragic effects of road accidents. The series of tragedies inspired me to innovate & develop a solution which got me into the roller coaster ride of being an innovator. Since then I’ve continued to solve problems and tried to bridge the gap with my innovation & research. I’ve got a couple of patents to my name and have received numerous B-Plans & innovation conclave awards. I’m a keen observer of life, which made me realize the patterns that exist in nature. From painting and writing to music and film, I believe that art and culture are essential to our understanding of the world around us.</p>
              <Div className="cs-height_25 cs-height_lg_20" />
              <p className="cs-m0">I am always seeking out new ways to broaden my horizons and expand my perspective. The past couple of years have been enlightening for me to understand the power of branding as a whole, since then I’m on a mission to revolutionize branding. I’m excited to connect with like-minded professionals and explore new opportunities to make a positive impact in the world.</p>
              <Div className="cs-height_45 cs-height_lg_30" />
              <SocialWidget />
            </Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg='150' md='80' />
      <Div className="container">
        <Cta
          title="Let&apos;s Build The <br />Next Big Thing Together! "
          btnText='Your Next Big Move Starts Here!'
          btnLink='/contact'
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
